export type EngagementEventType = "note" | "activity" | "opportunity" | "project" | "document" | "email" | "prospect";
export type Guid = string;

export enum EngagementPeriod {
  OneWeek = "OneWeek",
  OneMonth = "OneMonth",
  ThreeMonths = "ThreeMonths",
  SixMonths = "SixMonths",
  OneYear = "OneYear",
}

export type EngagementOperation = "created" | "updated" | "completed" | "createdandcompleted";

export type EngagementEvent = {
  entityId: Guid;
  type: EngagementEventType;
  operation: EngagementOperation;
  title: string;
  description: string;
  date: string; // ISO 8601
  link: string | null;
  companyId: Guid | null;
  companyName: string;
  userId: Guid | null;
  userName: string | null;
};

export type EngagementResponse = {
  items: EngagementEvent[];
  hasMore: boolean;
  nextCursor: string | null;
};

export type EngagementSummaryGroup = {
  date: string;
  entityType: EngagementEventType;
  count: number;
};

export type EngagementSummaryResponse = {
  groups: EngagementSummaryGroup[];
};

export type EngagementFilters = {
  companyIds?: Guid[];
  userIds?: Guid[];
  from?: string; // UTC ISO 8601 instant
  to?: string;
  types?: EngagementEventType[];
  search?: string;
  cursor?: string;
  pageSize?: number;
};
